import { ReleaseStatusBadge, SectionTitle } from '@/components/common';
import { formatDate } from '@/lib/format';
import type { LabProjectDetail } from '@/lib/types';

export function HistoryPanel({ history }: { history: LabProjectDetail['history'] }) {
  return (
    <section>
      <SectionTitle>Versions</SectionTitle>
      <ul className="divide-y rounded-lg border">
        {history.map((release) => (
          <li key={release.id} className="grid gap-2 p-4 sm:grid-cols-[8rem_10rem_minmax(0,1fr)] sm:items-start">
            <p className="font-medium">{release.version}</p>
            <div><ReleaseStatusBadge status={release.status} /></div>
            <div className="min-w-0 space-y-1 text-sm text-muted-foreground">
              <p>
                {release.publishedAt
                  ? `Published ${formatDate(release.publishedAt)}`
                  : release.submittedAt
                    ? `Submitted ${formatDate(release.submittedAt)}`
                    : 'Not submitted'}
              </p>
              {release.reviewNote && <p className="whitespace-pre-line text-foreground">{release.reviewNote}</p>}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
